import { customFetch } from '@skytech/auth'
import type {
  Translation,
  PostTranslationPayload,
  Locale,
  UpdateTranslationPayload,
} from '@skytech/types'

import { post } from '@/util/auth'

import { API_ROUTE_TRANSLATION, API_ROUTE_TRANSLATIONS } from './api-routes'

export const commonTranslationResources = {
  getList: () => customFetch<Record<Locale, Translation>>({ path: API_ROUTE_TRANSLATIONS }),

  // mutations
  post: (postTranslationPayload: PostTranslationPayload) =>
    customFetch({ path: API_ROUTE_TRANSLATIONS, method: 'POST', data: postTranslationPayload }),
  update: (updateTranslationPayload: UpdateTranslationPayload) =>
    post(API_ROUTE_TRANSLATION, updateTranslationPayload),
}
